(function() { window.GUID_dd3501f7_be15_48b6_a51d_b0c458411f5b = { getGuid: function() { return "dd3501f7-be15-48b6-a51d-b0c458411f5b"; } }; })();
var Kiosk;
(function (Kiosk) {
    $(function () {
        $('#UserEmail').on('keydown', function (e) {
            if (e.which == 13) {
                $('#btnSetUser').trigger('click');
            }
        });
        $('#btnSetUser').on('click', function () {
            window.location = CSParameters.BaseUrl + "Portal/Kiosk?UserEmail=" + $('#UserEmail').val();
        });
        $('body').on('contextmenu', function (e) {
            e.preventDefault();
            return false;
        });
        $(".PortalItemLink").on('click', function (e) {
            e.preventDefault(); //this will prevent the link trying to navigate to another page
            var href = $(this).attr("href"); //get the href so we can navigate later
            //alert(href);
            //when update has finished, navigate to the other page
            window.location.replace(href);
        });
    });
})(Kiosk || (Kiosk = {}));

//# sourceMappingURL=Kiosk.js.map
